import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./InventoryAudit.module.css";
import inventoryAuditTrailWhite from "../../assets/images/dashboard/inventory-audit-trail-white.svg";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";

let order = "desc";

export class InventoryAudit extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.inventoryAuditCard}`}>
          <Link to="/app/inventoryaudit">
            <div className={`card-header ${style.inventoryAuditHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={inventoryAuditTrailWhite} alt="Inventory Audit Trail" />
              Inventory Audit Trail
              </div>
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardData.inventoryLogList} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="name"
                isKey={true}
                // dataSort={true}
                width={"55%"}
              >
                Product Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="unique_code"
                // dataSort={true}
                width={"45%"}
              >
                Unique Code
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default InventoryAudit;

